import { Address, encodeFunctionData, WalletClient } from 'viem';

import stakingPoolAbi from 'modules/api/abi/DelegateStakingPool';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

export async function delegateClaim(
  walletClient: WalletClient,
  data: {
    poolAddress: Address;
  },
): Promise<Address> {
  const { poolAddress } = data;
  const encodedData = encodeFunctionData({
    abi: stakingPoolAbi,
    functionName: 'claimUnstakes',
  });

  const txHash = await walletClient.sendTransaction({
    to: asAddress(poolAddress),
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address || ''),
  });

  return txHash;
}
